var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIconGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6672 1.33475C14.2939 0.961419 13.8139 0.788086 13.3339 0.788086C12.8539 0.788086 12.3739 0.961419 12.0006 1.33475L6.89391 6.44142C6.74725 6.58809 6.62725 6.77475 6.57391 6.96142L5.69391 9.58809C5.56058 9.97475 5.86725 10.3348 6.22725 10.3348C6.28058 10.3348 6.34725 10.3214 6.41391 10.3081L9.04058 9.42809C9.24058 9.36142 9.41391 9.25475 9.56058 9.10808L14.6672 4.00142C15.4006 3.26809 15.4006 2.06809 14.6672 1.33475Z",
    fill: "#A9AFD9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.625 11.251C11.625 12.0072 11.0063 12.626 10.25 12.626H4.75C3.99375 12.626 3.375 12.0072 3.375 11.251V5.75098C3.375 4.99473 3.99375 4.37598 4.75 4.37598H6.93625L8.31125 3.00098H4.75C3.2375 3.00098 2 4.23848 2 5.75098V11.251C2 12.7635 3.2375 14.001 4.75 14.001H10.25C11.7625 14.001 13 12.7635 13 11.251V7.68973L11.625 9.06473V11.251Z",
    fill: "#A9AFD9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconGray);
export default __webpack_public_path__ + "static/media/edit_icon_gray.ed6e62cac2221115d51ef213f02c55d4.svg";
export { ForwardRef as ReactComponent };